/**
 * The organization types the API speaks, mirroring the backend `OrganizationType`
 * enum. The API sends the enum's CASE NAME, so these strings are the contract —
 * `organizer` here is `case organizer = 1` there.
 *
 * A dictionary rather than a bare union because the two sides drifted once
 * already: the backend called this case `event` while the frontend and the agent
 * both said `organizer`, so every consumer carried its own translation and the
 * agent silently fell back to a generic knowledge base. One named place is what
 * makes the next rename a compile error instead of a search.
 */
export const ORGANIZATION_TYPE = {
  none: 'none',
  organizer: 'organizer',
  partner: 'partner',
  admin: 'admin',
  attendee: 'attendee',
} as const;

export type OrganizationType = (typeof ORGANIZATION_TYPE)[keyof typeof ORGANIZATION_TYPE];

/**
 * The two types that own product routes and API segments — the value doubles as
 * the URL prefix (`/partner/...`, `/organizer/...`).
 */
export type OrganizationRole = Extract<
  OrganizationType,
  typeof ORGANIZATION_TYPE.partner | typeof ORGANIZATION_TYPE.organizer
>;
